import { render, staticRenderFns } from "./wzvz_overview.vue?vue&type=template&id=5ed55168&scoped=true"
import script from "./wzvz_overview.vue?vue&type=script&lang=js"
export * from "./wzvz_overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed55168",
  null
  
)

export default component.exports